<cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="showTotal" [showZeilenSelect]="showZeilenSelect">
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRowsBemerkung"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>
<ng-template #tableHeadersBemerkung>
  <tr>
    <th style="width: 40%">{{ "Art" | translate }}</th>
    <th style="width: 60%">{{ "Bemerkung" | translate }}</th>
  </tr>
</ng-template>
<ng-template #tableRowsBemerkung>
  @if (listLoader?.items) {
    @for (bemerkung of listLoader?.items; track bemerkung) {
      @for (version of bemerkung.versions; track version) {
        <tr>
          <td [capHistinfo]="version.histInfo" style="width: 40%">
            {{ version | avbemerkungArt | translate }}
          </td>
          <td style="width: 60%">
            <span [capHistinfo]="version.histInfo">
              {{ version.bemerkung }}
            </span>
            <cap-kompakt-timepoint [item]="version.histInfo?.bisTimePoint"></cap-kompakt-timepoint>
          </td>
        </tr>
      }
    }
  }
</ng-template>
